import React, { useState } from "react";
import CertificationSelectPopover, {
	CertificationSelectOption,
} from "./CertificationSelectPopover";

const OPTIONS: CertificationSelectOption[] = [
	{ key: "police-record-extract:school", name: "Polisregisterutdrag – skola" },
	{ key: "police-record-extract:care", name: "Polisregisterutdrag – vård" },
	{ key: "driving-license", name: "Körkort" },
	{ key: "vocational-identification", name: "Yrkeslegitimation" },
];

const CertificationSelectPopoverExample: React.FC = () => {
	const [selected, setSelected] = useState<string[]>(["driving-license"]);

	return (
		<div className="space-y-8 p-6">
			<div>
				<h3 className="mb-4 text-lg font-semibold">CertificationSelectPopover Example</h3>

				<div className="space-y-4">
					<div className="flex flex-wrap items-center gap-1.5">
						{selected.length === 0 ? (
							<p className="text-sm text-gray-500">Inga certifikat valda.</p>
						) : (
							selected.map((key) => {
								const o = OPTIONS.find((opt) => opt.key === key)!;
								return (
									<span
										key={key}
										className="rounded-full bg-amber-50 px-3 py-1 text-sm text-amber-900 ring-1 ring-inset ring-amber-200"
									>
										{o.name}
									</span>
								);
							})
						)}
					</div>

					<CertificationSelectPopover
						options={OPTIONS}
						selectedKeys={selected}
						onSelect={(key) => setSelected((prev) => [...prev, key])}
						onDeselect={(key) => setSelected((prev) => prev.filter((k) => k !== key))}
					/>

					<p className="text-sm text-gray-600">Selected: {selected.join(", ") || "none"}</p>
				</div>
			</div>
		</div>
	);
};

export default CertificationSelectPopoverExample;
